import { breakpoints } from './constants';

export const mediaQueryMap = {
  mobile: `(max-width:${breakpoints.mobileLandscape - 0.01}px)`,
  mobileLandscape: `(min-width:${
    breakpoints.mobileLandscape
  }px) and (max-width:${breakpoints.tablet - 0.01}px)`,
  tablet: `(min-width:${breakpoints.tablet}px) and (max-width:${
    breakpoints.laptop - 0.01
  }px)`,
  laptop: `(min-width:${breakpoints.laptop}px) and (max-width:${
    breakpoints.desktop - 0.01
  }px)`,
  desktop: `(min-width:${breakpoints.desktop}px)`,
};
